<template>
  <div
    class="time-tracking__project hover-highlight q-py-xs q-px-sm row items-center justify-between no-wrap"
    :class="{ 'cursor-pointer': clickable }"
    :style="{ 'background-color': active ? activeColor : null }"
    @click="$emit('click', $event)"
  >
    <div class="col-auto row items-center no-wrap">
      <div>
        <div class="time-tracking__project__color-indicator circle" :style="{ 'background-color': projectColor }"></div>
      </div>
      <span class="q-subheading block on-right ellipsis" :style="{ color: projectColor }">{{ projectName }}</span>
    </div>

    <div v-if="hasCustomer && !hideCustomer" class="col row items-center justify-end">
      <span class="q-body-1 text-faded block ellipsis on-right">{{ customerName }}</span>
    </div>
  </div>
</template>

<script>
  import { colors } from 'quasar'
  import { getCustomerName } from 'src/utils/searchResultParser'
  import i18n from 'src/i18n/i18n'

  export default {
    props: {
      project: {
        type: Object,
        required: false,
        default: () => ({
          'name': i18n.t('without_project'),
          'color_hex': '#7f7f7f',
          'customer': null
        })
      },

      active: {
        type: Boolean,
        default: false
      },

      clickable: {
        type: Boolean,
        default: false
      },

      hideCustomer: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      projectName () {
        return this.project.name
      },

      projectColor () {
        return this.project.color_hex
      },

      activeColor () {
        return colors.lighten(this.projectColor, 90)
      },

      hasCustomer () {
        return !!this.project.customer
      },

      customerName () {
        return getCustomerName(this.project.customer.data)
      }
    }
  }
</script>

<style lang="stylus">
  @import '~variables'

  .time-tracking
    &__project
      border-radius: 15px
      &__color-indicator
        width: 6px
        height: 6px
</style>
